import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=794c2e1f&scoped=true&"
import script from "./RightMenu.vue?vue&type=script&lang=js&"
export * from "./RightMenu.vue?vue&type=script&lang=js&"
import style0 from "./RightMenu.vue?vue&type=style&index=0&id=794c2e1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c2e1f",
  null
  
)

export default component.exports